const blogPosts = [
    {
    id: 1,
    title: 'How to Connect Java with Generative AI',
    date: 'May 30, 2025',
    readTime: '3 min read',
    description: 'Unlocking the power of OpenAI and Hugging Face in your Java applications',
    url: 'https://medium.com/javarevisited/how-to-connect-java-with-generative-ai-c3df715391a8',
  },
  {
    id: 2,
    title: 'Interesting Java Facts You Probably Did not Know',
    date: 'June 08, 2025',
    readTime: '4 min read',
    description: 'Exploring the java facts',
    url: 'https://dev.to/iammadhankumar/interesting-java-facts-you-probably-didnt-know-1hgp',
  },
  {
    id: 3,
    title: 'Java Design Patterns in Real Projects',
    date: 'June 14, 2025',
    readTime: '3 min read',
    description: 'Mastering Design Patterns to Solve Real Development Challenges',
    url: 'https://dev.to/iammadhankumar/java-design-patterns-in-real-projects-2fmf',
  },
  {
    id: 4,
    title: 'Java Features in 2025',
    date: 'June 22, 2025',
    readTime: '5 min read',
    description: 'A Comprehensive Overview Welcome to the Future of Java',
    url: 'https://dev.to/iammadhankumar/java-features-in-2025-479m',
  },
  {
    id: 5,
    title: 'Java Developer Skills Checklist in 2025',
    date: 'June 23, 2025',
    readTime: '3 min read',
    description: 'Explore the Must-Have Java Tech Stack That Makes You Stand Out',
    url: 'https://dev.to/iammadhankumar/java-developer-skills-checklist-in-2025-9i4',
  },
  {
    id: 6,
    title: 'Why Java Remains the Most In-Demand Programming Language in 2025',
    date: 'June 28, 2025',
    readTime: '3 min read',
    description: 'Explore how Java continues to lead in developer productivity, job market demand, and enterprise-grade ecosystem even in the fast-evolving tech landscape of 2025',
    url: 'https://dev.to/iammadhankumar/why-java-remains-the-most-in-demand-programming-language-in-2025-297l',
  },
  {
    id: 7,
    title: 'Java vs Kotlin in 2025: Which One to Choose and Why?',
    date: 'June 29, 2025',
    readTime: '3 min read',
    description: 'Java vs Kotlin',
    url: 'https://dev.to/iammadhankumar/java-vs-kotlin-in-2025-which-one-to-choose-and-why-1nhb',
  },
  {
    id: 8,
    title: 'Modern Java Features (Java 21+) Explained with Examples',
    date: 'July 1, 2025',
    readTime: '3 min read',
    description: 'Embrace simplicity, clarity, and power in your Java code',
    url: 'https://dev.to/iammadhankumar/modern-java-features-java-21-explained-with-examples-ko3',
  },
  {
    id: 9,
    title: 'Effective Microservices with Spring Cloud',
    date: 'July 6, 2025',
    readTime: '4 min read',
    description: 'Unlocking the Power of Spring Cloud for Modern Microservices Development',
    url: 'https://dev.to/iammadhankumar/effective-microservices-with-spring-cloud-2lcj',
  },
  {
    id: 10,
    title: 'Exception Handling Best Practices in Java',
    date: 'July 19, 2025',
    readTime: '3 min read',
    description: 'Mastering Checked and Unchecked Exceptions, Custom Classes, and Avoiding Common Pitfalls',
    url: 'https://dev.to/iammadhankumar/exception-handling-best-practices-in-java-15l7',
  },
  {
    id: 11,
    title: 'Why Java is Still a Top Backend Language in the AI Era',
    date: 'July 27, 2025',
    readTime: '4 min read',
    description: 'Explore how Java remains a powerful and reliable choice for backend development in modern AI-powered applications',
    url: 'https://dev.to/iammadhankumar/why-java-is-still-a-top-backend-language-in-the-ai-era-cdm',
  },
  {
    id: 12,
    title: 'Common Java Mistakes Developers Make',
    date: 'July 31, 2025',
    readTime: '7 min read',
    description: 'Discover the most frequent Java errors with simple explanations, practical code examples, and tips to improve your code quality',
    url: 'https://dev.to/iammadhankumar/common-java-mistakes-developers-make-2feo',
  },
  {
    id: 13,
    title: 'Reactive Programming in Java',
    date: 'Aug 04, 2025',
    readTime: '7 min read',
    description: 'Explore reactive programming before diving into implementation',
    url: 'https://dev.to/iammadhankumar/reactive-programming-in-java-4adn',
  },
  {
    id: 14,
    title: 'JUnit and Mockito Best Practices for Unit Testing in Java',
    date: 'Aug 09, 2025',
    readTime: '8 min read',
    description: 'JUnit and Mockito Best Practices',
    url: 'https://dev.to/iammadhankumar/junit-and-mockito-best-practices-for-unit-testing-in-java-4icb',
  },
  {
    id: 15,
    title: 'Build Mini Framework Using Java Reflection',
    date: 'Aug 14, 2025',
    readTime: '5 min read',
    description: 'Mastering reflection while crafting your own lightweight framwork',
    url: 'https://dev.to/iammadhankumar/build-mini-framework-using-java-reflection-21lm',
  },
  // Add more blog objects with readTime...
];

export default blogPosts;
